import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTheme } from 'styled-components'
import update from 'immutability-helper'

import {
    message, Select, Popconfirm, Space, Upload, Modal, List, Table, Tooltip,
    Skeleton
} from 'antd'

import {
    InboxOutlined, DeleteOutlined, CheckCircleFilled, EditOutlined, InfoCircleOutlined
} from '@ant-design/icons'

// Components
import LucideIcon, { Button, TextButton } from '../../../Reusable/Button'
import { Image } from '../../../Reusable/Image'
import { Text, Tag } from '../../../Reusable/Text'
import { FlexColumn, Flex, CardContainer } from '../../../Reusable/Container'
import { LabeledInput } from '../../../Reusable/Input'
import { ErrorAlert } from '../../../Reusable/Alert'
import environment from '../../../../environment'
import { SignedLink } from '../../../Reusable/Link'
import { apiPOSTReq } from '../../../../Utils/api'
import { addressObjectToStr, toCurrency, isEmailValid, getCodatPlatformName, isCodatUser } from '../../../../Utils/util'
import AddPaymentMethod from '../AddPaymentMethod'
import ModalClose from '../../../../Images/modal-close.png'
import TableView from '../../../Reusable/TableView'
import Unsyncable from '../../../../Images/unsyncable.svg'
import Banner from '../../../Reusable/Banner'
import { debounce } from 'lodash'
import DocumentUploadModal from '../DocumentUploadModal'
import { Eye, Trash } from 'lucide-react'

const docTypes = [
    {
        name: "Purchase Order",
        type: "PO",
    },
    {
        name: "Work Order",
        type: "WO",
    },
    {
        name: "Master Service Agreement",
        type: "MSA",
    },
    {
        name: "Other",
        type: "OTHER",
    }
]

const { Option } = Select
const { Dragger } = Upload

class EditVendor extends Component {

    constructor(props) {
        super(props)
        const vendor = props.vendor || {}
        vendor.billRecipientEmail = vendor.billRecipientEmail || [];
        if(!vendor.type) vendor.type = "Business";

        this.state = {
            paymentMethod: "ACH",
            accountType: "Checking",
            createVendorLoading: false,
            vendor: vendor,
        }
    }

    componentDidMount() {
        this.getPaymentMethods();
    }

    saveInput = (id, dataToSave) => {
        this.setState({ [id]: dataToSave })
    }

    saveVendorInput = (key, value) => {
        var { vendor } = this.state
        vendor[key] = value
        this.setState({ vendor })
    }

    debouncedSearch = debounce((searchTerm) => {
        if ((searchTerm || "").length > 2) {
            this.searchExistingRecipients(searchTerm);
        } else {
            this.setState({ existingCP: null });
        }
    }, 500);

    handleVendorTextChange = (event) => {
        var { vendor } = this.state;

        const vendorName = event.target.value;
        vendor[event.target.id] = vendorName;
        // Trigger the debounced search
        this.debouncedSearch(vendorName);
        this.setState({ vendor });
    }

    searchExistingRecipients = (name) => {
        const body = {
            "searchStr": name,
            "viewBy": "BusinessBanking" // Only returns CPs with this source application
        }
        this.setState({ searchLoading: true });
        apiPOSTReq(`${environment.integrationBaseUrl}/integration/semanticSearch/getBBCounterparties`, {}, body, (err, resp) => {
            try {
                this.setState({ searchLoading: false });
                const data = resp;
                if (data.result) {
                    this.setState({ cpSearchResult: data.searchResult, existingCP: data.counterpartiesObj });
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log({ description: error.message });
            }
        })
    }

    getVendorLocation = (location, formattedAddress) => {
        if (!location)
            this.setState({
                vendor: update(this.state.vendor, {
                    address: {
                        $set: {
                            line1: null,
                            line2: null,
                            city: null,
                            countrySubDivisionCode: null,
                            state: null,
                            postalCode: null
                        }
                    }
                })
            })
        else
            this.setState({
                vendor: update(this.state.vendor, {
                    address: {
                        $set: {
                            line1: location.line1,
                            line2: location.line2,
                            city: location.city,
                            countrySubDivisionCode: location.countrySubDivisionCode,
                            state: location.state,
                            postalCode: location.postalCode
                        }
                    }
                })
            })
    }

    getPaymentMethods = (options) => {
        options = options || {}
        var { vendor } = this.state
        if (options.vendor) vendor = options.vendor
        if (!vendor.associatedCPObjectId) {
            if(vendor.id) this.searchExistingRecipients(vendor.vendorName);
            return
        }
        const body = {
            "vendorId": vendor.associatedCPObjectId
        }
        this.setState({ loading: true })
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/getPaymentMethods`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                this.setState({ loading: false })
                const data = resp
                console.log("/payables/vendors/getPaymentMethods", data)
                if (data.result) {
                    var paymentMethods = data.paymentMethods || [];
                    paymentMethods = paymentMethods.filter(pm => (pm.type != "Wire"));
                    this.setState({ paymentMethods: paymentMethods });
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getPaymentMethods", error, resp)
                ErrorAlert({ description: error.message })
            }
        })
    }

    addPaymentMethod = (type) => {
        var { vendor } = this.state
        var { id } = vendor || {}
        if (!id) {
            this.handleSubmit(type)
            return
        }
        if ((type) == "ACH") this.setState({ showAddACHMethod: true })
        if ((type) == "Check") this.setState({ showAddCheckMethod: true })
    }

    makeDefaultPaymentMethod = (paymentMethod) => {
        const { vendor } = this.state
        const body = {
            "vendorId": vendor.id,
            "paymentMethodId": paymentMethod.id
        }
        this.setState({ loading: true })
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/makeDefaultPaymentMethod`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp || {}
                console.log("/payables/vendors/makeDefaultPaymentMethod resp", data)
                if (data.result) {
                    this.getPaymentMethods()
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR /ive/templates/makeDefault", error, resp)
                ErrorAlert({ description: error.message })
            }
        })
    }

    deletePaymentMethod = (paymentMethod) => {
        const { vendor } = this.state
        const body = {
            "vendorId": vendor.id,
            "paymentMethodId": paymentMethod.id
        }
        this.setState({ loading: true })
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/deletePaymentMethod`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp || {}
                console.log("/payables/vendors/deletePaymentMethod", data)
                if (data.result) {
                    this.getPaymentMethods()
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR /payables/vendors/deletePaymentMethod", error, resp)
                ErrorAlert({ description: error.message })
            }
        })
    }

    getPMView = () => {
        const { theme, bankingStore } = this.props
        var { vendor, paymentMethods, existingCP, searchLoading } = this.state
        var { bankDetail } = vendor || {}
        var { accountNumber } = bankDetail || {}
        var accountMask = accountNumber ? accountNumber.slice(-4) : ""
        paymentMethods = paymentMethods || []
        return (
            <FlexColumn style={{ width: "100%" }}>
                {/* {(paymentMethods.length > 0) && */}
                {
                    (existingCP && (paymentMethods.length == 0)) || searchLoading ?
                    <CardContainer fullWidth>
                        <Flex start between centerH gap='8px' style={{ marginBottom: '16px' }}>
                            <Text margin='0' weight={500} size='18px' color={theme.colors.primary2}>
                                Payment Methods
                            </Text>
                        </Flex>
                        
                        {
                            searchLoading ? 
                            <Skeleton loading={true} active title={false} paragraph={{ rows: 3 }}/>
                            :
                            <Banner start centerH gap='8px' 
                                message={
                                    <FlexColumn gap='4px'>
                                        <Text caption> We detected a potential match from your banking recipient list. Want to use the same bank details?</Text>
                                        <Text style={{ fontWeight: 500 }}>Name: {(existingCP || {}).nameOnAccount}</Text>
                                        <Flex start centerH gap='12px'>
                                            <TextButton onClick={() => this.syncCPWithVendor()} text='Yes' />
                                            <Text>OR</Text>
                                            <TextButton permtype="Payables.Vendors" onClick={() => this.setState({ showPaymentModal: true, editPm: null })} text='Setup as New' />
                                        </Flex>
                                    </FlexColumn>
                                }
                            />
                        }
                    </CardContainer>
                    :
                    <TableView
                        className='borderless-table'
                        titleText='Payment Methods'
                        style={{ width: "100%", marginBottom: 10 }}
                        loading={this.state.loading}
                        dataSource={paymentMethods}
                        pagination={false}
                        rowKey='id'
                        ctaContent={
                            <Flex center>
                                <a style={{ fontSize: 15 }} permtype="Payables.Vendors" onClick={() => this.setState({ showPaymentModal: true, editPm: null })}>Add Payment Method</a>
                            </Flex>
                        }
                        columns={[
                            {
                                title: 'Nickname',
                                dataIndex: 'nickName',
                                width: "200px",
                            },
                            {
                                title: 'Type',
                                dataIndex: 'type',
                                render: item => <Tag tagpreset={theme.colors.secondary8}>{item}</Tag>,
                                width: "80px",
                            },
                            {
                                title: 'Account',
                                dataIndex: 'bankDetail',
                                render: bankDetail =>
                                    <>
                                        {bankDetail.accountNumber && <Space style={{ color: theme.colors.secondary7 }}><span>{`•••••${bankDetail.accountNumber.substring(bankDetail.accountNumber.length - 4, bankDetail.accountNumber.length)}`}</span></Space>}
                                        {bankDetail.bankAddress && <span style={{ color: theme.colors.secondary7 }}><b>Mailing address: </b>{addressObjectToStr(bankDetail.bankAddress)}</span>}
                                    </>,
                                width: "35%",
                            },
                            {
                                title: '',
                                dataIndex: 'default',
                                render: (isdefault, record) => (
                                    <Flex start centerHorizontally style={{ gap: 8 }}>
                                        {isdefault && <Tag tagpreset={theme.colors.primary}>{"Default".toUpperCase()}</Tag>}
                                        {!isdefault && <a permtype="Payables.Vendors" style={{ whiteSpace: 'nowrap', marginBottom: 4 }} onClick={() => this.makeDefaultPaymentMethod(record)}>Make default</a>}
                                        {!isdefault && <a permtype="Payables.Vendors" onClick={() => this.deletePaymentMethod(record)}><DeleteOutlined style={{ fontSize: 18 }} /></a>}
                                        <a permtype="Receivables.Invoices" onClick={() => this.setState({ showPaymentModal: true, editPm: record })}><EditOutlined style={{ fontSize: 18 }} /></a>
                                    </Flex>
                                ),
                                align: "center",
                                width: "20%",
                            }]}
                    />
                }
            </FlexColumn>
        )
    }

    handleEmailChange = (event) => {
        this.setState({
            vendor: update(this.state.vendor, { billRecipientEmail: { [event.target.getAttribute('index')]: { $set: event.target.value } } })
        })
    }

    handleAddEmail = () => {
        this.setState({
            vendor: update(this.state.vendor, this.state.vendor.billRecipientEmail ? { billRecipientEmail: { $push: [null] } } : { billRecipientEmail: { $set: [null] } })
        })
    }

    handleDeleteEmail = (event) => {
        this.setState({
            vendor: update(this.state.vendor, { billRecipientEmail: { $splice: [[[event.currentTarget.getAttribute('index')], 1]] } })
        })
    }

    syncCPWithVendor = () => {
        var { existingCP, vendor } = this.state;
        if(!vendor.id) vendor.vendorName = existingCP.nameOnAccount;
        vendor.associatedCPObjectId = existingCP.objectId;
        this.setState({ vendor, existingCP: null }, this.saveVendor({ fetchPM: true }));
    }

    saveVendor = (options) => {
        var { fetchPM } = options || {};
        var { vendor, fromAccount, paymentMethod, accountNumber, routingNumber, checkAddress } = this.state;
        const { vendorName, primaryEmail, type } = vendor;

        var successMessage = vendor.id ? "Vendor updated successfully!" : "Vendor created successfully!"

        if (!type) {
            ErrorAlert({ description: "Please select a type for this vendor." })
            return
        }

        if (!vendorName) {
            ErrorAlert({ description: "Please enter a vendor name." })
            return
        }

        if (vendorName.includes('|')) {
            ErrorAlert({ description: "Please enter a valid vendor name." })
            return
        }

        if (primaryEmail && !isEmailValid(primaryEmail)) {
            ErrorAlert({ description: "Please enter a valid email." })
            return
        }

        if (vendor.primaryEmail === "") {
            vendor.primaryEmail = null
        }

        this.setState({ createVendorLoading: true })

        const body = {
            "vendor": vendor,
            "saveToQBO": this.state.saveToQBO,
        }

        console.log("/payables/vendors/save", JSON.stringify(body))
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/save`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                this.setState({ loading: false })
                const data = resp
                console.log("/payables/vendors/save", JSON.stringify(data))
                if (data.result) {
                    this.setState({ vendor: data.vendor, editvendor: data.editvendor, createVendorLoading: false });
                    message.success(successMessage);

                    const updatedVendor = data.vendor;

                    // // Then go back
                    this.props.history.goBack();

                    // Wait a short time to ensure navigation completes
                    setTimeout(() => {
                        // Then directly update the vendor in the VendorDetails component's state
                        if (this.props.history.location.pathname === '/payables/vendors/details') {
                            this.props.history.replace({
                                pathname: '/payables/vendors/details',
                                state: { 
                                    vendor: updatedVendor,
                                    updatedVendor: updatedVendor 
                                }
                            });
                        }
                    }, 100);

                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                this.setState({ createVendorLoading: false })
                console.log("ERRR /payables/vendors/save", error, err, resp)
                ErrorAlert({ description: error.message })
            }
        })
    }

    render() {
        var { theme, aionStore } = this.props
        const { vendor, createVendorLoading, existingCP, searchLoading } = this.state

        var { vendorName, primaryEmail, primaryPhone, taxId, address, type, customerId, billRecipientEmail } = vendor

        return (
            <FlexColumn start>
                <FlexColumn>
                    <Flex start style={{ width: "100%" }} gap='24px'>
                        <CardContainer shadow style={{ width: "50%" }} padding='12px 24px 24px'>
                            <FlexColumn start style={{ marginBottom: 12, marginRight: 12 }} gap='16px'>
                                {/* <Text color='#444444' margin="10px 0 0 0">Vendor Details</Text> */}

                                <LabeledInput
                                    label="Type"
                                    type='switch'
                                    switchNames={['Business', 'Individual']}
                                    onChange={(value) => this.saveVendorInput("type", value)}
                                    value={vendor.type}
                                    nomargin
                                />

                                <LabeledInput
                                    autoFocus
                                    label="Name"
                                    labelcolor={theme.colors.secondary3}
                                    id="vendorName"
                                    key="vendorName"
                                    placeholder="Enter vendor name"
                                    value={vendorName}
                                    onChange={this.handleVendorTextChange}
                                    nomargin
                                />

                                {
                                    !vendor.id && existingCP &&
                                    <Banner start centerH gap='8px' 
                                        message={
                                            <FlexColumn gap='4px'>
                                                <Text caption>We detected a potential match from your banking recipient list. Want to use the same details?</Text>
                                                <Text style={{ fontWeight: 500 }}>Name: {(existingCP || {}).nameOnAccount}</Text>
                                                <Flex start centerH gap='12px'>
                                                    <TextButton onClick={() => this.syncCPWithVendor()} text='Use Matched Recipient' />
                                                </Flex>
                                            </FlexColumn>
                                        }
                                    />
                                }

                                <LabeledInput
                                    optional
                                    label="Email"
                                    labelcolor={theme.colors.secondary3}
                                    id="primaryEmail"
                                    key="primaryEmail"
                                    placeholder="Enter email"
                                    value={primaryEmail}
                                    onChange={this.handleVendorTextChange}
                                    nomargin
                                />

                                <LabeledInput
                                    optional
                                    label="Phone"
                                    labelcolor={theme.colors.secondary3}
                                    id="primaryPhone"
                                    key="primaryPhone"
                                    placeholder="Enter phone number"
                                    value={primaryPhone}
                                    onChange={this.handleVendorTextChange}
                                    maxLength={10}
                                    nomargin
                                />

                                <LabeledInput
                                    optional
                                    label={(type !== "Individual") ? "EIN" : "SSN"}
                                    labelcolor={theme.colors.secondary3}
                                    id="taxId"
                                    key="taxId"
                                    placeholder="373888567"
                                    value={taxId}
                                    onChange={this.handleVendorTextChange}
                                    maxLength={9}
                                    nomargin
                                    unsyncable={isCodatUser(aionStore)}
                                    accountingSoftware={getCodatPlatformName(aionStore)}
                                />

                                <LabeledInput
                                    optional
                                    label={"Customer ID"}
                                    id="customerId"
                                    key="customerId"
                                    placeholder="Add an ID"
                                    value={customerId}
                                    onChange={this.handleVendorTextChange}
                                    nomargin
                                    maxLength='10'
                                    instruction="This ID will be automatically added when making a bill payment to help your vendors easily identify it"
                                    unsyncable={isCodatUser(aionStore)}
                                    accountingSoftware={getCodatPlatformName(aionStore)}
                                />

                                <LabeledInput
                                    label='Bill payment notification email'
                                    id="emails"
                                    key="emails"
                                    type="multi-email"
                                    nomargin
                                    onChange={(billRecipientEmail) => {
                                        vendor.billRecipientEmail = billRecipientEmail
                                        console.log("EditVendor nextStep customer:", billRecipientEmail)
                                        this.setState({ vendor })
                                    }}
                                    onDelete={(index) => {
                                        var emails = []

                                        for (var i = 0; i < billRecipientEmail.length; i++) {
                                            if (i != index) emails.push(billRecipientEmail[i])
                                        }

                                        vendor.billRecipientEmail = emails
                                        this.setState({ vendor })
                                    }}
                                    emails={billRecipientEmail && billRecipientEmail}
                                    instruction="Email of the recipient(s) that will receive bill payment notifications"
                                    unsyncable={isCodatUser(aionStore)}
                                    accountingSoftware={getCodatPlatformName(aionStore)}
                                    optional
                                />

                                <LabeledInput
                                    optional
                                    id="address"
                                    key="address"
                                    label="Address"
                                    labelcolor={theme.colors.secondary3}
                                    type="location"
                                    getLocation={this.getVendorLocation}
                                    Line2
                                    address={address}
                                    value={address && address.line1 ?
                                        { line1: addressObjectToStr(address), line2: address.line2 } : null
                                    }
                                    placeholder="Address"
                                    nomargin
                                />

                                <Flex start style={{ width: "100%", marginTop: 48 }}>
                                    <Button permtype="Payables.Vendors" solid loading={createVendorLoading} onClick={() => this.saveVendor()} text='Save' />
                                </Flex>
                            </FlexColumn>
                        </CardContainer>
                    </Flex>

                </FlexColumn>
                <Modal
                    visible={this.state.showPaymentModal}
                    footer={null}
                    closable={true}
                    width={700}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ showPaymentModal: false, editPm: null })}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <AddPaymentMethod
                        pm={this.state.editPm}
                        vendor={vendor}
                        onSave={(updatedVendor) => {
                            this.setState({ showPaymentModal: false, vendor: updatedVendor }, this.getPaymentMethods({ vendor: updatedVendor }))
                        }} />
                </Modal>
            </FlexColumn>
        )
    }
}

function mapStateToProps(state) {
    return {
        bkStore: state.bookkeepingAppReducer,
        aionStore: state.aionAppReducer,
        bankingStore: state.bankingAppReducer,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(EditVendor))